import React from 'react';
import * as Sentry from '@sentry/react';
import {
  isChunkLoadError,
  reloadForStaleChunk,
} from 'src/utils/staleChunkReload';

/**
 * Similar to `React.lazy` but this will force-reload the page on a chunk load
 * error (stale deploy). Reloading happens no more than once every 5 minutes.
 */
export default function lazy(_import) {
  return React.lazy(async () => {
    try {
      const component = await _import();
      return component;
    } catch (error) {
      // Only force-refresh on chunk/asset load failures after a deploy.
      if (isChunkLoadError(error) && reloadForStaleChunk()) {
        // Return a promise that never resolves to prevent React from trying
        // to render anything while the page is reloading
        return new Promise(() => {});
      }

      // Disable the feedback dialog, this error is not from user input
      Sentry.setContext('feedbackDialog', { hide: true });

      // If we shouldn't force-reload, then let the error bubble up.
      throw error;
    }
  });
}
